module.exports = __webpack_public_path__ + "static/forma-b7ab859b1f930e723d464c1ccf2be4e0.svg";